<template>
  <div class="pa-0 ma-0">
    <!-- v-if="canHome && !canBack && !single" -->
    <v-btn icon @click="$emit('onPrev')" :disabled="!isPrev" v-if="!single">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
    <v-btn icon @click="$emit('onNext')" :disabled="!isNext" v-if="!single">
      <v-icon>mdi-arrow-down</v-icon>
    </v-btn>
    <v-btn icon @click="$emit('onClose')" v-if="single">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    canHome: Boolean,
    single: Boolean,
    isPrev: Boolean,
    isNext: Boolean
  }
}
</script>

<style lang="scss" scoped></style>
